<template>
  <div class="text-left" v-if="event && !executing">

    <div v-if="!group.isPrivate">
      <label>Overall Event Visibility</label>
      <mdb-switch :checked="event.publiclyVisible" @getValue="handlePublic" offLabel="Private" onLabel="Public"/>
    </div>

    <div class="mb-2">
      <label>Who can see the <i>description detail</i>?</label>
      <mdb-input id="det1" label="Public" name="det1" radioValue="Public" type="radio"
                 v-model="event.detailsVisibility" v-if="event.publiclyVisible"/>
      <mdb-input id="det2" label="Members" name="det2" radioValue="Members" type="radio"
                 v-model="event.detailsVisibility"/>
      <mdb-input id="det3" label="Confirmed Members" name="det3" radioValue="Confirmed Members" type="radio"
                 v-model="event.detailsVisibility"/>
    </div>
    <div class="mb-2">
      <label>Who can see the <i>venue</i>?</label>
      <mdb-input id="venue1" label="Public" name="venue1" radioValue="Public" type="radio"
                 v-model="event.venueVisibility" v-if="event.publiclyVisible"/>
      <mdb-input id="venue2" label="Members" name="venue2" radioValue="Members" type="radio"
                 v-model="event.venueVisibility"/>
      <mdb-input id="venue3" label="Confirmed Members" name="venue3" radioValue="Confirmed Members" type="radio"
                 v-model="event.venueVisibility"/>
    </div>
    <div class="mb-2">
      <label>Who can see the <i>host</i>?</label>
      <mdb-input id="host1" label="Public" name="host1" radioValue="Public" type="radio"
                 v-model="event.hostVisibility" v-if="event.publiclyVisible"/>
      <mdb-input id="host2" label="Members" name="host2" radioValue="Members" type="radio"
                 v-model="event.hostVisibility"/>
      <mdb-input id="host3" label="Confirmed Members" name="host3" radioValue="Confirmed Members" type="radio"
                 v-model="event.hostVisibility"/>
    </div>
    <div class="mb-2">
      <label>Who can see the <i>attendee list</i>?</label>
      <mdb-input id="att1" label="Public" name="att1" radioValue="Public" type="radio"
                 v-model="event.attendeeVisibility" v-if="event.publiclyVisible"/>
      <mdb-input id="att2" label="Members" name="att2" radioValue="Members" type="radio"
                 v-model="event.attendeeVisibility"/>
      <mdb-input id="att3" label="Confirmed Members" name="att3" radioValue="Confirmed Members" type="radio"
                 v-model="event.attendeeVisibility"/>
    </div>
    <div class="mb-2">
      <label>Who can see the <i>image gallery</i>?</label>
      <mdb-input id="gall1" label="Public" name="gall1" radioValue="Public" type="radio"
                 v-model="event.imageVisibility"  v-if="event.publiclyVisible"/>
      <mdb-input id="gall2" label="Members" name="gall2" radioValue="Members" type="radio"
                 v-model="event.imageVisibility"/>
      <mdb-input id="gall3" label="Confirmed Members" name="gall3" radioValue="Confirmed Members" type="radio"
                 v-model="event.imageVisibility"/>
    </div>

    <mdb-btn icon="save" color="success" @click="doSave">Save</mdb-btn>
    <mdb-btn icon="times-circle" color="danger" @click="doCancel">Cancel</mdb-btn>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </div>

</template>

<script>
  import api from '../../services/groupsPlaceApi.js'
  import {mdbBtn, mdbIcon, mdbInput, mdbSwitch} from 'mdbvue';
  import SeriesModal from "./SeriesModal";

  export default {
    name: 'Event-Visibility-Editor',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbSwitch,
      SeriesModal
    },
    props: {
      id: {
        type: Number,
        default: null
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },
    data() {
      return {
        event: null,
        showSeriesModal: false,
        seriesChoice: null
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/visibility/" + this.id).then(
        (results) => {
          this.event = results.data;
          if (this.group.isPrivate) {
            this.event.publiclyVisible = false
            this.disablePublic()
          }
        },
        (error) => {
          this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      disablePublic: function() {
        if (this.event.attendeeVisibility == 'Public') this.event.attendeeVisibility = "Members"
        if (this.event.detailsVisibility == 'Public') this.event.detailsVisibility = "Members"
        if (this.event.hostVisibility == 'Public') this.event.hostVisibility = "Members"
        if (this.event.imageVisibility == 'Public') this.event.iamgeVisibility = "Members"
        if (this.event.venueVisibility == 'Public') this.event.venueVisibility = "Members"
      },
      handlePublic: function (val) {
        this.event.publiclyVisible = val
        if (!val) {
          this.disablePublic()
        }
      },
      doCancel() {
        this.$emit("cancel")
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.doSave()
      },
      doSave() {
        if (this.event.repeats && !this.event.series && !this.event.status != "Draft") {
          this.showSeriesModal = true
          return
        }

        this.$store.dispatch("setExecuting", true);
        api.post('/event/visibility/' + this.id, this.event).then(
          (results) => {
            this.$emit("save")
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
          this.showSeriesModal = false
          this.seriesChoice = null
        })
      }
    }
  }
  ;
</script>
